<script setup lang="ts">
const { slug } = useRoute().params
const { locale } = useI18n()
const { $preview } = useNuxtApp()

const version = $preview ? 'draft' : 'published'

const story = await useAsyncStoryblok(
    `stories/${slug}`,
    {
        version,
        language: locale.value,
    },
)
</script>

<template>
    <div>
        <StoryblokComponent
            v-if="story"
            :blok="story.content"
        />
    </div>
</template>
